import React from 'react';
const cuadernillos = [{
  icon: '📘',
  title: 'Cuadernillo 1 — 1° Año: Introducción a la Química y Sistemas Materiales',
  desc: 'Conceptos fundamentales, materia, propiedades, estados de agregación, modelo de partículas, transformaciones físicas y químicas.'
}, {
  icon: '📗',
  title: 'Cuadernillo 2 — 2° Año: Estructura Atómica y Tabla Periódica',
  desc: 'Modelos atómicos, partículas subatómicas, Z-A-N, isótopos, iones, tabla periódica, propiedades periódicas.'
}, {
  icon: '📙',
  title: 'Cuadernillo 3 — 3° Año: El Mapa Electrónico y las Uniones Químicas',
  desc: 'Números cuánticos, configuración electrónica, bloques de la tabla, enlace iónico, covalente y metálico, estructuras de Lewis.'
}, {
  icon: '📕',
  title: 'Cuadernillo 4 — 4° Año: Química Inorgánica y Reacciones',
  desc: 'Nomenclatura inorgánica, óxidos, hidróxidos, ácidos, sales, reacciones químicas, estequiometría.'
}, {
  icon: '📔',
  title: 'Cuadernillo 5 — 5° Año: Química Orgánica, Salud y Ambiente',
  desc: 'Compuestos orgánicos, funciones oxigenadas y nitrogenadas, polímeros, bioquímica básica, química ambiental.'
}];
export function CuadernillosDetail() {
  return <section className="pt-10 pb-20 px-4 bg-white" data-id="element-70">
      <div className="max-w-4xl mx-auto" data-id="element-71">
        <div className="text-center mb-16" data-id="element-72">
          <h2 className="text-4xl font-black text-brand-dark mb-4" data-id="element-73">
            Lo que recibís
          </h2>
          <div className="inline-block bg-brand-blue text-white font-bold px-6 py-2 rounded-lg text-xl" data-id="element-74">
            📘 SECUNDARIA — 5 Cuadernillos
          </div>
          <p className="text-xl text-gray-600 mt-4 font-medium" data-id="element-75">
            Para docentes de Química de 1° a 5° año
          </p>
        </div>

        <div className="space-y-6" data-id="element-76">
          {cuadernillos.map((c, i) => <div key={i} className="bg-white border-2 border-gray-100 p-6 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow flex flex-col md:flex-row gap-6 items-start" data-id="element-77">
              <div className="text-6xl flex-shrink-0" data-id="element-78">{c.icon}</div>
              <div data-id="element-79">
                <h3 className="text-2xl font-bold text-brand-dark mb-3" data-id="element-80">
                  {c.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-81">
                  {c.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}